import { motion } from "framer-motion";
import { Flame, Droplets, Wind } from "lucide-react";

const features = [
  {
    icon: Flame,
    title: "Cera de Soja Premium",
    desc: "100% natural, sin parafina. Combustion limpia de hasta 60 horas por vela.",
  },
  {
    icon: Droplets,
    title: "Fragancias Artesanales",
    desc: "Perfiles aromaticos creados por perfumistas mexicanos con aceites esenciales puros.",
  },
  {
    icon: Wind,
    title: "Experiencia Phygital",
    desc: "Cada vela incluye un QR unico que desbloquea un ritual digital personalizado.",
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } },
};

export default function ProductSection() {
  return (
    <section
      id="producto"
      data-testid="product-section"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 items-center">
          {/* Image */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={fadeUp}
            className="md:col-span-5"
          >
            <div className="relative group">
              <div className="absolute -inset-4 bg-[#D4AF37]/5 blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
              <img
                src="https://images.pexels.com/photos/17675580/pexels-photo-17675580.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="Vela premium Serena"
                className="relative w-full aspect-[3/4] object-cover"
                data-testid="product-image"
              />
              <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-[#050505] to-transparent" />
            </div>
          </motion.div>

          {/* Content */}
          <div className="md:col-span-7 md:pl-8">
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-100px" }}
              variants={{ visible: { transition: { staggerChildren: 0.15 } } }}
            >
              <motion.p variants={fadeUp} className="text-xs uppercase tracking-[0.3em] text-[#D4AF37]/80 mb-4">
                Producto
              </motion.p>
              <motion.h2
                variants={fadeUp}
                className="font-serif text-4xl md:text-5xl font-normal tracking-tight leading-tight mb-6 text-white"
                data-testid="product-heading"
              >
                Mas que una vela,
                <br />
                <span className="italic text-[#D4AF37]">un ritual</span>
              </motion.h2>
              <motion.p
                variants={fadeUp}
                className="text-base md:text-lg text-white/50 leading-relaxed mb-12 max-w-lg"
              >
                Cada vela Serena esta pensada como una invitacion al bienestar.
                Fabricadas artesanalmente en Mexico con ingredientes premium y un
                proposito: acompanarte en tus momentos de calma.
              </motion.p>

              <div className="space-y-8">
                {features.map((f, i) => (
                  <motion.div
                    key={i}
                    variants={fadeUp}
                    className="flex items-start gap-5 group"
                    data-testid={`product-feature-${i}`}
                  >
                    <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center border border-[#D4AF37]/20 bg-[#D4AF37]/5 group-hover:border-[#D4AF37]/50 transition-colors duration-500">
                      <f.icon size={20} className="text-[#D4AF37]" />
                    </div>
                    <div>
                      <h3 className="font-sans text-sm font-semibold text-white mb-1 uppercase tracking-wide">
                        {f.title}
                      </h3>
                      <p className="text-sm text-white/40 leading-relaxed">
                        {f.desc}
                      </p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
